const cartData = (state = null, action) => {
  if (action.type === "SET_CART_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CART_DATA": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default cartData;
